// extracted by mini-css-extract-plugin
module.exports = {"spinner":"button-loader_spinner__Pvfkh","parent":"button-loader_parent__qstor"};